import { Link } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'
import { useProductStock } from '@/api/warehouse'
import { casesNote, itemLink, quantityLabel } from './model'
import { ConditionPill, PlacesList } from './stock-table'

/** On a product's page: what we hold of it in our warehouse, one row per condition. Hidden when none. */
export function ProductWarehouseStock({ productUuid }: { productUuid: string }) {
  const { data } = useProductStock(productUuid)
  if (!data?.length) return null
  return (
    <section aria-labelledby="product-warehouse" className="overflow-hidden rounded-xl border bg-card">
      <h2 id="product-warehouse" className="border-b px-4 py-3 text-sm font-semibold">
        In our warehouse
      </h2>
      <ul className="divide-y">
        {data.map((item) => {
          const perCase = item.product.units_per_case
          const note = casesNote(item.quantity_available, perCase)
          return (
            <li key={`${item.condition}-${item.used_grade ?? ''}`}>
              <Link
                {...itemLink(item)}
                className="flex items-center gap-3 px-4 py-2.5 text-sm transition-colors hover:bg-muted/40"
              >
                <span className="min-w-0 flex-1">
                  <ConditionPill stock={item} />
                  <PlacesList lots={item.lots} className="mt-1 text-xs text-muted-foreground" />
                </span>
                <span className="shrink-0 text-right tabular-nums">
                  <span className="font-semibold">{quantityLabel(item.quantity_available, perCase)}</span>
                  <span className="text-muted-foreground"> available</span>
                  {note && <span className="block text-[11px] text-muted-foreground">{note}</span>}
                </span>
                <ChevronRight className="size-4 shrink-0 text-muted-foreground" aria-hidden />
              </Link>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
